import { render, staticRenderFns } from "./ConfigSectionForm.vue?vue&type=template&id=56cc4190&scoped=true"
import script from "./ConfigSectionForm.vue?vue&type=script&lang=js"
export * from "./ConfigSectionForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigSectionForm.vue?vue&type=style&index=0&id=56cc4190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc4190",
  null
  
)

export default component.exports